import { parseBulkDiaryIdsSearch } from "@/features/patients/features/overview/table/bulk/bulkSearch";
import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout for `/patients/bulk/events` and `/patients/bulk/events/$eventType`. */
export const Route = createFileRoute("/_app/patients/bulk/events")({
    validateSearch: (search: Record<string, unknown>) => parseBulkDiaryIdsSearch(search),
    component: () => <Outlet />,
});
